"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedDownButtonStyle = void 0;
const typestyle_1 = require("typestyle");
exports.SpeedDownButtonStyle = (0, typestyle_1.stylesheet)({
    button: {
        transform: 'rotate(180deg)'
    }
});
